<template>
  <b-col class="col-12 position-relative">
    <div class="dot m-auto">
      <b-link v-if="id" class="text-body align-content-center" :title="$t('rating.delete')" @click.prevent="clickDelete">
        <span class="icon-delete_filled" aria-hidden="true"></span>
      </b-link>
    </div>

    <b-modal :id="'confirmRatingDelete_'+ id" centered hide-header-close @ok="doDelete" class="delete-container">
      <template slot="modal-title">
        {{ $t('rating.confirm_delete.title') }}
      </template>
      {{ $t('rating.confirm_delete.text') }}
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('rating.confirm_delete.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('rating.confirm_delete.yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal :id="'offLineModalRating_'+ id" centered hide-header-close @ok="hideModal" class="network-modal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>

export default {
  name: 'RatingDelete',
  props: ['id', 'apiary', 'colony'],
  methods: {
    async clickDelete () {
      if (navigator.onLine) {
        this.showModal()
      } else {
        this.showOffLineModal()
      }
    },
    showModal () {
      this.$bvModal.show('confirmRatingDelete_' + this.id)
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalRating_' + this.id)
    },
    hideModal () {
      this.$bvModal.hide('offLineModalRating_' + this.id)
    },
    async doDelete () {
      this.$emit('confirmDelete', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';
  .delete-container {
    font-family: $font-family-sans-serif;
  }
  .network-modal {
    font-family: $font-family-sans-serif;
  }
  .dot {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
</style>
